import React from 'react';

export interface ResponsiveImageSources {
  original: string;
  webp320?: string | null;
  webp640?: string | null;
  webp960?: string | null;
}

type Props = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet' | 'alt'> & {
  src: string;
  alt: string;
  sources?: ResponsiveImageSources | null;
  sizes: string;
};

const ResponsiveImage: React.FC<Props> = ({ src, sources, sizes, alt, ...props }) => {
  const candidates = [
    sources?.webp320 && `${sources.webp320} 320w`,
    sources?.webp640 && `${sources.webp640} 640w`,
    sources?.webp960 && `${sources.webp960} 960w`,
  ].filter(Boolean).join(', ');

  return (
    <picture className="contents">
      {candidates && <source type="image/webp" srcSet={candidates} sizes={sizes} />}
      <img src={sources?.original || src} sizes={sizes} alt={alt} {...props} />
    </picture>
  );
};

export default ResponsiveImage;
